import _ from 'lodash'
import * as R from 'ramda'

import { SET_ANSWERS, SET_ENTITIES } from '../../actions'

const answersReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_ANSWERS: {
      const answers = action.answers.map((answer) =>
        _.merge({}, answer, {
          answer_detail: answer.answer_detail && answer.answer_detail.id,
        })
      )
      return _.merge(
        {},
        state,
        _.keyBy(answers, (answer) => answer.id)
      )
    }
    case SET_ENTITIES:
      return R.merge(state, action.entities.answers)

    default:
      return state
  }
}

export default answersReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/answers.js